export type { ChipProps } from '../../types/chip';
export type { ChipGroupItem, ChipGroupProps } from '../../types/chip-group';
export { Chip } from './adapters/inbound/Chip';
export { ChipGroup } from './adapters/inbound/ChipGroup';
